import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import toast from 'react-hot-toast';
import {
  uploadOfflineMachinesForStore,
  type MachineUploadResponse,
  type MachineUploadPayload,
} from 'api/admin/machines/machines';
import { ApiError } from 'types/api';

export const useUploadOfflineMachinesForStore = () => {
  return useMutation<unknown, ApiError, MachineUploadPayload>({
    mutationFn: async ({ storeId, machineList }) => {
        if (!storeId || !machineList) {
            return null;
        }
        
        const formData = new FormData();
        formData.append('storeId', String(storeId));
        formData.append('machineList', machineList);
      
        const { data } = (await uploadOfflineMachinesForStore(formData)) as AxiosResponse<MachineUploadResponse>;

      return data;
    },
    onSuccess: () => {
        toast(
            'Successfully submitted machine file for upload',
            {
              duration: 4000,
            },
          );
    },
    onError: (error) => {
      Sentry.captureException(error);
      toast.error(
        error?.response?.data?.error ??
          'An error occurred while uploading offline machines for the store',
        {
          duration: 4000,
        },
      );
    },
  });
};
